
























import { mixins } from "vue-class-component";
import { Vue, Component } from "vue-property-decorator";
import { ClickOutsideDirective } from "../../../../helpers/directives/clickOutside.directive";
import FloatMenuAnimation from "../../../../resources/mixins/animations/floatMenuAnimation";
import { LAYOUT_TYPE } from "../../../../resources/constants/meeting";
@Component({
  name: "layout-types-component",

  directives: { ClickOutsideDirective },
})
export default class LayoutTypesComponent extends mixins(FloatMenuAnimation) {
  LAYOUT_TYPES = LAYOUT_TYPE;
  mounted () {
    let type = localStorage.getItem("layout");
    if (type)
      this.selectType(type);
  }
  close(): void {
    const menu = document.getElementById("layout-types-container");
    if (menu.style.display === "block") this.closeLayoutTypes();
  }
  getLayoutTypeImage(type) {
    return require(`@/assets/images/icons/${type}.svg`);
  }
  selectType(type) {
    this.$store.dispatch("MeetingStore/setLayoutTypeAction", type);
    localStorage.setItem("layout", type);
    setTimeout(() => {
      this.close();
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20);
  }
}
